import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { gcalApi } from "./gcalApi";

export const getGcalConnectionStatus = createAsyncThunk(
  "gcalConnect/getStatus",
  async (providerId) => {
    try {
      return await gcalApi.getStatus({ provider_id: providerId });
    } catch (error) {
      // Status is passive chrome on page load — fail silently, manual entry still works.
      return null;
    }
  }
);

export const completeGcalConnection = createAsyncThunk(
  "gcalConnect/connect",
  async ({ providerId, code }) => {
    try {
      const data = await gcalApi.connect({ provider_id: providerId, code });
      toast.success("Google Calendar connected");
      return data;
    } catch (error) {
      toast.error(error?.message || "Failed to connect Google Calendar");
      return null;
    }
  }
);

export const disconnectGcal = createAsyncThunk(
  "gcalConnect/disconnect",
  async (providerId) => {
    try {
      await gcalApi.disconnect({ provider_id: providerId });
      toast.success("Google Calendar disconnected");
      return true;
    } catch (error) {
      toast.error(error?.message || "Failed to disconnect Google Calendar");
      return null;
    }
  }
);

export const gcalConnectSlice = createSlice({
  name: "gcalConnectStore",
  initialState: {
    status: null, // { connected, authorize_url, connection } per spec §6
    loading: { status: false, connect: false, disconnect: false },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGcalConnectionStatus.pending, (state) => {
        state.loading.status = true;
      })
      .addCase(getGcalConnectionStatus.fulfilled, (state, action) => {
        state.loading.status = false;
        if (action.payload) state.status = action.payload;
      })
      .addCase(completeGcalConnection.pending, (state) => {
        state.loading.connect = true;
      })
      .addCase(completeGcalConnection.fulfilled, (state, action) => {
        state.loading.connect = false;
        if (action.payload?.connection) {
          state.status = {
            ...(state.status || {}),
            connected: true,
            connection: action.payload.connection,
          };
        }
      })
      .addCase(disconnectGcal.pending, (state) => {
        state.loading.disconnect = true;
      })
      .addCase(disconnectGcal.fulfilled, (state, action) => {
        state.loading.disconnect = false;
        if (action.payload) {
          state.status = { ...(state.status || {}), connected: false, connection: null };
        }
      });
  },
});

export default gcalConnectSlice.reducer;
